import { webApi } from '@mi-front/api-clients';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Deletes a video editor project and refreshes the fragment’s BFF project list query.
 */
export function useProjectCardDelete(projectId: string, fragmentId: string) {
  const queryClient = useQueryClient();

  const deleteMutation = webApi.useDeleteVideoEditorProjectsProject({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: webApi.listProjectsVideoEditorProjectsQueryKey({ fragmentId }),
        });
      },
    },
  });

  const handleDelete = async () => {
    await deleteMutation.mutateAsync({ id: projectId });
  };

  return { handleDelete };
}
